import { EntityKinds } from '@internal/backstage-plugin-common-library-react';

import { Entity } from '@backstage/catalog-model';

export enum Tier {
  NeedsFocus = 'needsFocus',
  Good = 'good',
  Elite = 'elite',
  NA = 'N/A',
}

export const TierColors: Record<Tier, string> = {
  [Tier.NeedsFocus]: '#CD7F32',
  [Tier.Good]: '#C0C0C0',
  [Tier.Elite]: '#FFD700',
  [Tier.NA]: '#808080',
};

export enum AllCategories {
  eolUpcoming = 'EOL Upcoming - AWS',
  aiGovernance = 'AI Governance',
  doraReadiness = 'DORA Operational Readiness',
  costOptimization = 'Cost Optimization',
  engIntelligence = 'Eng Intelligence',
  codeCoverage = 'Code coverage',
  scorecardOnboarding = 'Scorecard Onboarding',
  productionReadiness = 'Production Readiness',
  documentationCoverage = 'Documentation Coverage',
}

export type ScorecardItem = {
  checked: boolean;
  color: string;
  label: string;
  valueOverTime: { date: string; value: number | string | null }[];
};

export type NaReason = 'not_applicable' | 'no_data' | 'no_ownership_confirmed';

export type CategoryPeriodValue = {
  category_score_percentage: number;
  category_score_proportion_dividend: number;
  category_score_proportion_denominator: number;
  aggregated_category_badge: string;
  aggregated_category_score_percentage: number;
  aggregated_category_score_proportion_dividend: number;
  aggregated_category_score_proportion_denominator: number;
  team_id: string;
  na_reason?: NaReason | null;
  repositories: {
    repository_name: string;
    pushed_at?: string;
    checks: any;
  }[];
  children: CategoryPeriodValue[];
};

export type CategoryPeriod = {
  end: string;
  start: string;
  value: CategoryPeriodValue;
};

export type CategoryData = {
  category: string;
  error?: boolean;
  data: {
    end_date: string;
    start_date: string;
    unit: string;
    periods: CategoryPeriod[];
  };
};

export const LabelsForTier: Record<Tier, string> = {
  [Tier.NeedsFocus]: 'Needs Focus',
  [Tier.Good]: 'Good',
  [Tier.Elite]: 'Elite',
  [Tier.NA]: 'Not Applicable',
};

export type CategoryBadge =
  | 'N/A'
  | 'EXCELLENT'
  | 'ON_TRACK'
  | 'CAUTION'
  | 'CRITICAL';

export const LabelsForStringTier: Record<string, string> = {
  CRITICAL: 'Critical',
  CAUTION: 'Caution',
  ON_TRACK: 'On Track',
  EXCELLENT: 'Excellent',
  'N/A': 'Not Applicable',
};

export const RouteForCategory = Object.fromEntries(
  Object.entries(AllCategories).map(([key, value]) => [value, key]),
) as Record<AllCategories, keyof typeof AllCategories>;

export type CheckV2 = {
  checkName: string;
  passed: boolean;
  label: string;
  checkDetails: any[];
  description: string;
};

export type CategoryScore = {
  category: string;
  score: number | 'N/A';
  description?: string;
  checks?: CheckV2[];
  tier: string;
  failed?: boolean;
  periodLabel?: string;
  periodStart?: string;
  periodEnd?: string;
  naReason?: NaReason | null;
};

export type ScorecardV2 = {
  entityName: string;
  entityKind: EntityKinds;
  score: number;
  categoryScores: CategoryScore[];
};

export enum UnownedEntityStatus {
  noUnowned = 'No unowned',
  needsAttention = 'Needs attention',
}

export type FixableCategory =
  | 'Velocity'
  | 'End of Life'
  | 'Privileged Identity Management'
  | 'Key Rotation'
  | 'Agent Coverage'
  | 'Public IP'
  | 'Criticality Set'
  | 'Blackduck Coverage'
  | 'Veracode Coverage'
  | 'Repository Ownership'
  | 'Subscription Ownership'
  | 'Resource Group Tag';

export interface FixButtonProps {
  context: any;
  entity: Entity;
  performDataRefresh?: () => void;
}
